export class MaterialMovementHistory {
  company?: number;
  type?: string;
  modifiedDate?: Date;
  modifiedBy?: string;
  quantity?: number;
  quantityBefore?: number;
  quantityAfter?: number;
  location?: string;
  subLocation?: string;
}
